module.exports = __webpack_public_path__ + "static/media/logo.7b5a5a19.png";